import React from 'react'

import VideoConference from '../videoConference'

export default () => {
  return <VideoConference />
}
